// ntfy CLIENT-side (2026-07-10) — publica push pro celular a partir do
// RENDERER (Electron/Mac), não do Worker.
//
// Por quê: Worker CF → ntfy.sh é hostil entre zonas Cloudflare (medido com
// worker-sonda: POST puro = erro CF 1042, com UA browser = 1104, JSON root =
// 522 em ~20s — o anti-bot do ntfy.sh trata egress de Worker como bot). Do
// desktop o publish é instantâneo e o ntfy.sh responde CORS `*`, então o
// fetch do renderer funciona. Runs LOCAIS (Play do card + cron do Electron)
// são orquestrados AQUI — o push nasce aqui também. O caminho Worker-side
// (lib/ntfy.js) permanece para NTFY_SERVER self-hosted (fora de zona CF).
//
// Limite conhecido: o access token NÃO é publicável daqui (GET /api/settings
// REDIGE NTFY_TOKEN — correto). Tópico protegido por token ⇒ use self-host +
// caminho Worker. Best-effort e swallow-safe: nunca falha um run.
import { apiFetch } from './api.js';

const DEFAULT_SERVER = 'https://ntfy.sh';
const MAX_BODY_CHARS = 600;

/** Lê a config ntfy visível ao client (token é redigido — fica de fora). */
export async function loadClientNtfyConfig() {
  try {
    const res = await apiFetch('/api/settings');
    if (!res?.ok) return null;
    const map = {};
    for (const s of res.data?.settings || []) map[s.key] = s.value;
    const topic = (map.NTFY_TOPIC || '').trim();
    if (!topic) return null;
    return {
      topic,
      server: (map.NTFY_SERVER || DEFAULT_SERVER).trim().replace(/\/+$/, '') || DEFAULT_SERVER,
      notifyAgents: map.NTFY_NOTIFY_AGENTS !== '0',
    };
  } catch {
    return null;
  }
}

/** Publica UMA notificação do renderer. Nunca lança; true/false. */
export async function publishNtfy(config, { title, message, tags, priority } = {}) {
  try {
    if (!config?.topic) return false;
    const headers = { 'Content-Type': 'text/plain; charset=utf-8' };
    if (title) headers.Title = String(title).slice(0, 120);
    if (tags) headers.Tags = String(tags);
    if (priority) headers.Priority = String(priority);
    const res = await fetch(`${config.server || DEFAULT_SERVER}/${config.topic}`, {
      method: 'POST',
      headers,
      body: String(message || '').slice(0, MAX_BODY_CHARS),
    });
    return !!res?.ok;
  } catch {
    return false;
  }
}

/**
 * Push de fim de run LOCAL de agente (Play do card + cron do Electron).
 * Espelha o notifyAgentRun do Worker (ok E failed; gate NTFY_NOTIFY_AGENTS).
 */
export async function notifyLocalRunFromClient(task, { status, output, error } = {}) {
  try {
    const cfg = await loadClientNtfyConfig();
    if (!cfg || !cfg.notifyAgents) return false;
    // Anti-duplicata: com NTFY_SERVER self-hosted o WORKER publica com sucesso
    // (recordLocalRun → notifyAgentRun); o client só cobre o caso que o Worker
    // comprovadamente não alcança — o ntfy.sh default (bloqueio entre zonas CF).
    if (cfg.server !== DEFAULT_SERVER) return false;
    const okRun = status === 'ok';
    const name = String(task?.name || 'Agente').replace(/\s+—\s+auto$/, '');
    return await publishNtfy(cfg, {
      title: okRun ? `${name} concluiu` : `${name} falhou`,
      message: okRun ? (output || '(sem output)') : (error || 'erro desconhecido'),
      tags: okRun ? 'white_check_mark,robot' : 'x,robot',
      priority: okRun ? '3' : '4',
    });
  } catch {
    return false;
  }
}
